export enum PageType {
    Map,
    Stream,
    History,
}
